import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function SignInRequired() {
  const { state, pathname, search } = useLocation();
  const from = state?.from || `${pathname}${search}` || "/";

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Header />

      <main className="mx-auto max-w-[900px] px-4 sm:px-6 xl:px-8 py-12">
        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm p-8">
          <div className="flex items-center gap-4">
            <div className="h-10 w-10 rounded-xl bg-slate-100 grid place-items-center">
              <span className="text-xl">🔒</span>
            </div>
            <div>
              <h1 className="text-2xl font-bold">Please sign in to add items to your cart</h1>
              <p className="mt-1 text-slate-600">
                You need an account to keep your selections. Sign in or create a new account to continue.
              </p>
            </div>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              className="inline-flex items-center justify-center rounded-xl bg-black px-5 py-2.5 text-white font-medium hover:opacity-90 active:opacity-80"
              to={`/login?redirect=${encodeURIComponent(from)}`}
            >
              Sign in
            </Link>
            <Link
              className="inline-flex items-center justify-center rounded-xl border border-slate-300 px-5 py-2.5 font-medium hover:bg-slate-50"
              to={`/signup?redirect=${encodeURIComponent(from)}`}
            >
              Create account
            </Link>
          </div>

          <div className="mt-6 grid gap-3 sm:grid-cols-3">
            <div className="rounded-xl border border-slate-200 p-4">
              <div className="text-slate-500 text-sm">Save choices</div>
              <div className="mt-1 text-slate-800 text-sm">Keep your cart synced across devices.</div>
            </div>
            <div className="rounded-xl border border-slate-200 p-4">
              <div className="text-slate-500 text-sm">Faster checkout</div>
              <div className="mt-1 text-slate-800 text-sm">We’ll prefill your trip details.</div>
            </div>
            <div className="rounded-xl border border-slate-200 p-4">
              <div className="text-slate-500 text-sm">Manage bookings</div>
              <div className="mt-1 text-slate-800 text-sm">Track, edit and rebook easily.</div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
